import type { ModularLocaleModules } from '../../types';

export const ruModules = {
  "common": {
    "nav": {
      "home": "Главная",
      "products": "Продукция",
      "technology": "Технологии",
      "about": "О нас",
      "contact": "Контакты",
      "faq": "Часто задаваемые вопросы"
    },
    "footer": {
      "contact": "Свяжитесь с нами",
      "phone": "Телефон",
      "email": "электронная почта",
      "address": "Адрес",
      "rights": "Все права защищены.",
      "brandDesc": "Профессиональный производитель инфракрасных обогревателей. Предоставляя миру тепло, комфорт и энергоэффективность с 2006 года.",
      "products": "Продукция",
      "support": "Поддержка",
      "newsletter": "Оставайтесь в курсе",
      "newsletterDesc": "Подпишитесь, чтобы получать последние обновления продуктов и новости отрасли.",
      "join": "Присоединяйтесь",
      "catalog": "Скачать каталог",
      "emailPlaceholder": "Введите адрес электронной почты",
      "product1": "Инфракрасный обогреватель",
      "product2": "Портативный обогреватель",
      "product3": "",
      "product4": "",
      "privacy": "Политика конфиденциальности",
      "terms": "Условия использования",
      "sitemap": "Карта сайта",
      "installationGuide": "Руководство по установке",
      "warrantyPolicy": "Гарантийная политика"
    }
  },
  "home": {
    "hero": {
      "future": "Будущее отопления",
      "title": "Эффективный и экологичный",
      "subtitle": "Инфракрасное отопление",
      "description": "Принесите солнечное тепло в открытые пространства. Наша передовая технология дальнего инфракрасного диапазона обеспечивает мгновенное, бесшумное и энергоэффективное лучистое тепло для патио ресторанов, садов, мастерских и зон у бассейнов.",
      "cta": "Смотреть продукцию",
      "watchVideo": "Посмотреть видео",
      "trusted": "Нам доверяют более 5000 клиентов",
      "worldwide": "Распространение по всему миру",
      "slides": {
        "slide5": {
          "title": "Кантонская ярмарка",
          "subtitle": "До встречи в Гуанчжоу",
          "description": "Встретьтесь с JH Heatsup на Кантонской ярмарке. Познакомьтесь с нашими решениями для отопления и обсудите сотрудничество.",
          "exhibition": {
            "eyebrow": "JH HEATSUP · КАНТОНСКАЯ ЯРМАРКА",
            "date": "15–19 октября 2026",
            "venue": "Выставочный комплекс Кантонской ярмарки, Гуанчжоу",
            "boothLabel": "НАШ СТЕНД",
            "booth": "Павильон 3.2 · Стенд L16"
          }
        },
        "slide4": {
          "title": "Выставка Global Sources",
          "subtitle": "Потребительская электроника",
          "description": "Встретьтесь с JH Heatsup в Гонконге. Познакомьтесь с нашими решениями для отопления и обсудите возможности сотрудничества.",
          "exhibition": {
            "eyebrow": "JH HEATSUP · ВЫСТАВКА В ГОНКОНГЕ",
            "date": "11–14 октября 2026",
            "venue": "AsiaWorld-Expo, Гонконг",
            "boothLabel": "НАШ СТЕНД"
          }
        },
        "slide1": {
          "title": "Эффективный и экологичный",
          "subtitle": "Инфракрасное отопление",
          "description": "Принесите солнечное тепло в открытые пространства. Наша передовая технология дальнего инфракрасного диапазона обеспечивает мгновенное, бесшумное и энергоэффективное лучистое тепло для патио ресторанов, садов, мастерских и зон у бассейнов."
        },
        "slide2": {
          "title": "Безопасный и надежный",
          "subtitle": "Создан для повседневного использования",
          "description": "Разработан с водонепроницаемостью IPX4, защитой от перегрева и прочными материалами. Наши инфракрасные обогреватели обеспечивают стабильное и надежное тепло день за днем ​​— их можно безопасно использовать всю ночь."
        },
        "slide3": {
          "title": "Ультра тихий",
          "subtitle": "Мирное тепло",
          "description": "Наслаждайтесь тихим, естественным сияющим теплом без бликов, не пересушивая воздух и не распространяя пыль. Здоровое инфракрасное отопление для домов и офисов."
        }
      }
    },
    "about": {
      "title": "О JH Heatsup",
      "subtitle": "Лидер в области инфракрасных технологий с 2006 года.",
      "intro1": "Fujian Jinghui Environmental Technology Co., Ltd. (JH Heatsup) — ведущий производитель инфракрасных обогревателей в Китае, специализирующийся на энергоэффективных излучающих обогревателях дальнего инфракрасного диапазона для жилого и коммерческого использования.",
      "intro2": "Мы уделяем особое внимание исследованиям и разработкам, производству OEM/ODM и глобальной дистрибуции, чтобы поставлять высококачественные инфракрасные обогреватели оптовым покупателям по всему миру. Наша продукция имеет сертификаты CE, CB, SAA и RoHS и экспортируется в более чем 80 стран Европы, Австралии, Ближнего Востока и Юго-Восточной Азии.",
      "stats": {
        "yearsExperience": "Лет опыта",
        "countriesExported": "Стран экспорта",
        "patents": "Патентов",
        "satisfaction": "Довольных клиентов"
      },
      "ceoQuote": "«Мы стремимся создать более зеленый и теплый мир с помощью технологий».",
      "ceoLabel": "- Сообщение генерального директора",
      "factoryAlt": "Заводская линия по производству инфракрасных обогревателей JH Heatsup"
    },
    "features": {
      "title": "Почему стоит выбрать инфракрасные обогреватели JH",
      "subtitle": "Наша технология дальнего инфракрасного диапазона имитирует принцип естественного солнечного нагрева, нагревая непосредственно объекты и людей, а не только воздух. Это делает инфракрасные обогреватели на 80% более энергоэффективными, чем традиционные конвекционные обогреватели.",
      "energy": {
        "title": "Энергоэффективный",
        "desc": "Эффективность преобразования тепла до 99 % — инфракрасные излучающие обогреватели потребляют на 80 % меньше электроэнергии, чем конвекционные обогреватели."
      },
      "quiet": {
        "title": "Ультра тихий",
        "desc": "Безвентиляторный инфракрасный дизайн с нулевым светом, нулевым шумом и нулевой циркуляцией пыли"
      },
      "safe": {
        "title": "Безопасный и надежный",
        "desc": "Водонепроницаемые инфракрасные обогреватели IPX4 со встроенной защитой от перегрева, безопасны для использования на открытом воздухе и в помещении."
      },
      "smart": {
        "title": "Умное управление",
        "desc": "Управление приложением Wi-Fi Tuya для удаленного планирования температуры — экономьте энергию на своем телефоне"
      }
    },
    "categoriesSection": {
      "title": "Продукция по категориям",
      "subtitle": "Выберите инфракрасные, портативные и газовые обогреватели для вашего пространства — от открытых террас до гостиных.",
      "viewAll": "Посмотреть все продукты",
      "cards": {
        "infrared": {
          "badge": "Популярный",
          "tagline": "Дальние инфракрасные излучающие обогреватели для эффективного и целенаправленного обогрева.",
          "description": "Идеально подходит для открытых патио, террас ресторанов, мастерских, складов и настенного отопления помещений.",
          "cta": "Купить сейчас"
        },
        "portable": {
          "tagline": "Портативные обогреватели из углеродного волокна и галогенов для гибкого обогрева.",
          "description": "Отлично подходит для домов, офисов, обогрева под столом и развлекательных зон на открытом воздухе.",
          "cta": "Купить сейчас"
        },
        "gas": {
          "tagline": "Газовые обогреватели и столы с очагом для тепла на открытом воздухе",
          "description": "Создайте уютное пространство на террасах ресторанов, в садах и для встреч во внутреннем дворике.",
          "cta": "Купить сейчас"
        }
      }
    },
    "ctaSection": {
      "title": "Готовы обновить отопление?",
      "subtitle": "Свяжитесь с JH Heatsup сегодня, чтобы узнать оптовые цены, услуги OEM/ODM и бесплатную консультацию.",
      "cta": "Получить предложение"
    }
  },
  "products": {
    "title": "Вся продукция",
    "subtitle": "Откройте для себя идеальное решение для обогрева вашего помещения",
    "viewDetails": "Посмотреть детали",
    "header": {
      "title": "Вся продукция",
      "subtitle": "Откройте для себя идеальное решение для отопления вашего дома, офиса или промышленного помещения."
    },
    "filters": {
      "all": "Все",
      "searchPlaceholder": "Поиск продуктов..."
    },
    "catalog": "Скачать полный каталог",
    "discoverMore": "Узнайте больше",
    "viewSpecs": "Посмотреть характеристики",
    "categories": {
      "infraredHeater": "Инфракрасный обогреватель",
      "portableHeater": "Портативный обогреватель",
      "gasHeater": "Газовые обогреватели для патио"
    },
    "navDesc": {
      "infrared": "Излучающие панели для стен и потолка",
      "portable": "Отдельностоящие, настольные и подвесные",
      "gas": "Обогреватели для патио и каминные столики"
    },
    "viewAllProducts": "Посмотреть все продукты",
    "gasSubtitle": "Уличные газовые обогреватели и каминные столы для террас и гостиных.",
    "categoryLanding": {
      "gas": {
        "title": "Газовые обогреватели для патио и каминные столы",
        "subtitle": "Наружное отопление мощностью от 8 кВт до 50 000 БТЕ, с горелками из нержавеющей стали 304, стеклянными ветрозащитными экранами и конфигурациями для сжиженного нефтяного газа, соответствующими рынку вашего назначения.",
        "empty": "В этой категории товаров не найдено."
      },
      "infrared": {
        "title": "Инфракрасные обогреватели",
        "subtitle": "Энергоэффективные излучающие обогреватели дальнего инфракрасного диапазона для патио, ресторанов, мастерских и жилых помещений. Настенные и потолочные варианты мощностью от 1000 Вт до 4000 Вт.",
        "empty": "В этой категории товаров не найдено."
      },
      "portable": {
        "title": "Портативные обогреватели",
        "subtitle": "Гибкие решения для отопления дома и на рабочем месте: легко перемещаются, быстро нагреваются, созданы для повседневного комфорта.",
        "empty": "В этой категории товаров не найдено."
      }
    },
    "detail": {
      "technicalSpecs": "Технические характеристики",
      "relatedProducts": "Сопутствующие продукты {{category}}",
      "requestQuote": "Запросить цену",
      "backToProducts": "Вернуться к продуктам",
      "productNotFound": "Товар не найден",
      "specsAvailableOnRequest": "Технические характеристики предоставляются по запросу.",
      "noMatchingProducts": "Нет подходящих товаров",
      "noProducts": "Нет данных о продукте"
    },
    "items": {
      "p1": {
        "name": "Серия 13A",
        "description": "Энергоэффективный уличный дальний инфракрасный обогреватель с арочными нагревательными элементами для аэрокосмической отрасли. Модели мощностью 1000–4000 Вт для веранд, ресторанов и мастерских.",
        "longDescription": "Серия 13A — это надежный обогреватель дальнего инфракрасного диапазона, предназначенный для наружных и полуоткрытых помещений. В отличие от традиционных конвекционных обогревателей, которые тратят энергию на нагрев воздуха, этот инфракрасный обогреватель преобразует до 99% электроэнергии в тепло, что снижает энергопотребление до 80%. Прочные аэрокосмические нагревательные элементы с арочной пластиной обеспечивают большую излучающую поверхность для равномерного распределения тепла. Водонепроницаемость и бесшумная работа по стандарту IPX4 делают его идеальным для патио ресторанов, открытых террас, соляриев и мастерских. Доступны мощности от 1000 Вт до 4000 Вт для покрытия площадей от 10 м² до 50 м².",
        "category": "Инфракрасный обогреватель",
        "features": [
          "Экологичный",
          "Безопасно и тихо",
          "Длительный срок службы",
          "350°C, высокая температура"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "NR10/18/24/32/40-13A"
          },
          {
            "label": "Мощность",
            "value": "2400W"
          },
          {
            "label": "Площадь покрытия",
            "value": "30 m²"
          },
          {
            "label": "Напряжение/частота",
            "value": "230V, 50/60Hz"
          },
          {
            "label": "Номинальный ток",
            "value": "10.4A"
          },
          {
            "label": "Температура поверхности",
            "value": "300°C"
          },
          {
            "label": "Размерность",
            "value": "1500×189×67mm"
          },
          {
            "label": "Н/Г Вес",
            "value": "8.8/10.6 kg"
          }
        ]
      },
      "p2": {
        "name": "Серия 13B",
        "description": "Инфракрасный обогреватель с дистанционным управлением, термостатом и светодиодным индикатором. Энергоэффективное настенное отопление для гостиных, спален и офисов.",
        "longDescription": "Серия 13B — это классический настенный инфракрасный обогреватель с отличными энергосберегающими характеристиками. Оснащенный встроенным термостатом и пультом дистанционного управления, он автоматически поддерживает желаемую температуру — без лишних затрат энергии. Красный светодиодный индикатор сразу показывает состояние нагрева. Прочные аэрокосмические нагревательные элементы с арочной пластиной обеспечивают эффективность преобразования электроэнергии в тепло на уровне 99%. Бесшумное сияющее тепло без пыли делает его идеальным для гостиных, спален и офисов, где важен тихий комфорт.",
        "category": "Инфракрасный обогреватель",
        "features": [
          "Пульт дистанционного управления",
          "Светодиодный индикатор",
          "Экологичный",
          "Высокая эффективность",
          "300°С Поверхность"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "NR10/18/24/32-13B"
          },
          {
            "label": "Мощность",
            "value": "2400W"
          },
          {
            "label": "Площадь покрытия",
            "value": "30 m²"
          },
          {
            "label": "Напряжение/частота",
            "value": "230V, 50/60Hz"
          },
          {
            "label": "Номинальный ток",
            "value": "10.4A"
          },
          {
            "label": "Температура поверхности",
            "value": "300°C"
          },
          {
            "label": "Размерность",
            "value": "1500×189×67mm"
          },
          {
            "label": "Н/Г Вес",
            "value": "8.8/10.6 kg"
          }
        ]
      },
      "p3": {
        "name": "Серия 13C",
        "description": "Дальний инфракрасный обогреватель для террасы со встроенным динамиком Bluetooth. 4 уровня мощности, панель с нанопокрытием. Идеально подходит для ресторанов на открытом воздухе и развлекательных заведений.",
        "longDescription": "Серия 13C сочетает в себе инфракрасное отопление и развлечения — обогреватель и динамик Bluetooth в одном. Слушайте музыку с телефона через встроенный 3D-стереодинамик, наслаждаясь тишиной и сияющим теплом. Нагревательная панель с нанопокрытием обеспечивает высокую излучательную способность инфракрасного излучения для эффективного преобразования энергии. Четыре режима мощности (25%/50%/75%/100%) позволяют регулировать тепловую мощность для любого случая. Идеально подходит для открытых патио ресторанов, развлекательных зон и полуоткрытых комфортных помещений, где атмосфера имеет такое же значение, как и тепло.",
        "category": "Инфракрасный обогреватель",
        "features": [
          "Bluetooth-динамик",
          "4 уровня мощности",
          "Дальний инфракрасный комфорт",
          "Bluetooth-аудио",
          "Тихая работа"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "NR10/18/24/32-13C"
          },
          {
            "label": "Мощность",
            "value": "1800W"
          },
          {
            "label": "Площадь покрытия",
            "value": "20 m²"
          },
          {
            "label": "Напряжение/частота",
            "value": "230V, 50/60Hz"
          },
          {
            "label": "Номинальный ток",
            "value": "7.8A"
          },
          {
            "label": "Температура поверхности",
            "value": "300°C"
          },
          {
            "label": "Размерность",
            "value": "1370×189×67mm"
          },
          {
            "label": "Н/Г Вес",
            "value": "8.3/10.2 kg"
          },
          {
            "label": "Загрузка контейнера",
            "value": "705/1632; 480/1156; 355/884; 270/612"
          }
        ]
      },
      "p4": {
        "name": "Серия 22B",
        "description": "Стеклокерамический инфракрасный панельный обогреватель премиум-класса с управлением через приложение Wi-Fi Tuya. Лучистое отопление мощностью 1600–3200 Вт для современных гостиных и офисов.",
        "longDescription": "Серия 22B — это панельный инфракрасный обогреватель премиум-класса со стеклокерамическими нагревательными поверхностями, выдерживающими температуру до 950°C. Особое отражение стекла придает любой комнате элегантный и современный вид. Управляйте отоплением удаленно через приложение Wi-Fi Tuya или прилагаемый пульт — устанавливайте графики, регулируйте температуру и экономьте энергию со своего телефона. Обеспечивает чистое лучистое тепло без шума, вентиляторов и сухого воздуха. Длины волн дальнего инфракрасного диапазона также полезны для здоровья, способствуя обмену веществ. Доступны модели мощностью 1600 Вт, 2200 Вт и 3200 Вт, охватывающие площадь 20–40 м².",
        "category": "Инфракрасный обогреватель",
        "features": [
          "Wi-Fi приложение Tuya",
          "Пульт дистанционного управления",
          "Стеклянная Керамическая Панель",
          "Быстрый нагрев",
          "Здравоохранение"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "NR16/22/32-22B"
          },
          {
            "label": "Мощность",
            "value": "1.6/2.2/3.2 kW"
          },
          {
            "label": "Площадь покрытия",
            "value": "20/30/40 m²"
          },
          {
            "label": "Напряжение/частота",
            "value": "220-240V~50/60Hz"
          },
          {
            "label": "Номинальный ток",
            "value": "7/9.6/13.9A"
          },
          {
            "label": "Температура поверхности",
            "value": "380°C"
          },
          {
            "label": "Размерность",
            "value": "810/1160/1660 × 180 × 77 mm"
          },
          {
            "label": "Н/Г Вес",
            "value": "5/6.1; 7/8.2; 9.9/11.7 kg"
          },
          {
            "label": "Загрузка контейнера",
            "value": "728/1638; 507/1162; 377/826"
          }
        ]
      },
      "p5": {
        "name": "Серия 13W",
        "description": "Умный Wi-Fi-обогреватель дальнего инфракрасного диапазона с водонепроницаемостью IPX4. Лучистое отопление с управлением через приложение для внутренних и наружных патио, балконов и террас.",
        "longDescription": "Серия 13W сочетает приложение Tuya WiFi, пульт LCD, индикацию LED и четыре уровня мощности. Для помещений и крытых террас или балконов с подходящей стеной нужны совместимые кронштейны и зазоры модели. IPX4 обозначает защиту от брызг.",
        "category": "Инфракрасный обогреватель",
        "features": [
          "Wi-Fi приложение Tuya",
          "Светодиодный дисплей",
          "ЖК-пульт дистанционного управления",
          "4 уровня мощности",
          "IPX4 Водонепроницаемый"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "NR10/18/24/32-13W"
          },
          {
            "label": "Мощность",
            "value": "1.0/1.8/2.4/3.2 kW"
          },
          {
            "label": "Площадь покрытия",
            "value": "10/20/30/40 m²"
          },
          {
            "label": "Напряжение/частота",
            "value": "220-240V~50/60Hz"
          },
          {
            "label": "Номинальный ток",
            "value": "4.3/7.8/10.4/13.9A"
          },
          {
            "label": "Температура поверхности",
            "value": "300°C"
          },
          {
            "label": "Размерность",
            "value": "755/1150/1655/2155 × 189 × 67 mm"
          },
          {
            "label": "Н/Г Вес",
            "value": "4.4/5.5; 6.9/8.1; 9.5/11.3; 12.3/14.3 kg"
          },
          {
            "label": "Загрузка контейнера",
            "value": "840/1680/2100; 530/1080/1350; 570/900/980; 350/700/800"
          }
        ]
      },
      "p6": {
        "name": "Серия 14A",
        "description": "Классический арочный обогреватель дальнего инфракрасного диапазона с панелью с нанопокрытием. Энергоэффективное лучистое отопление мощностью 1000–4000 Вт для террас, патио и балконов.",
        "longDescription": "Серия 14A оснащена арочной панелью с нанопокрытием мощностью от 1000W до 4000W, без встроенного управления. Выберите подходящую стену внутри помещения или в крытой зоне и уточните кронштейны, зазоры и управление модели. IPX4 обозначает защиту от брызг.",
        "category": "Инфракрасный обогреватель",
        "features": [
          "Арка Дизайн",
          "Множественная мощность",
          "IPX4 Водонепроницаемый",
          "Быстрый нагрев",
          "Энергоэффективный"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": ""
          },
          {
            "label": "Мощность",
            "value": ""
          },
          {
            "label": "Площадь покрытия",
            "value": ""
          },
          {
            "label": "Напряжение/частота",
            "value": ""
          },
          {
            "label": "Номинальный ток",
            "value": ""
          },
          {
            "label": "Температура поверхности",
            "value": ""
          },
          {
            "label": "Размерность",
            "value": ""
          },
          {
            "label": "Н/Г Вес",
            "value": ""
          },
          {
            "label": "Загрузка контейнера",
            "value": ""
          }
        ]
      },
      "p7": {
        "name": "Серия 14B",
        "description": "Настенный инфракрасный обогреватель с пультом для помещений и крытых террас с подходящей стеной.",
        "longDescription": "Серия 14B сочетает арочную панель с нанопокрытием, пульт, индикацию LED, четыре уровня мощности и таймер 0/2/4/6/8 часов. Монтаж — на подходящей стене в помещении или крытой зоне с совместимыми кронштейнами и нужными зазорами. Тонкий корпус не означает совместимость с другими конструкциями.",
        "category": "Инфракрасный обогреватель",
        "features": [
          "Пульт дистанционного управления",
          "Функция таймера",
          "Арка Дизайн",
          "IPX4 Водонепроницаемый",
          "Быстрый нагрев"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": ""
          },
          {
            "label": "Мощность",
            "value": ""
          },
          {
            "label": "Площадь покрытия",
            "value": ""
          },
          {
            "label": "Напряжение/частота",
            "value": ""
          },
          {
            "label": "Номинальный ток",
            "value": ""
          },
          {
            "label": "Температура поверхности",
            "value": ""
          },
          {
            "label": "Размерность",
            "value": ""
          },
          {
            "label": "Н/Г Вес",
            "value": ""
          },
          {
            "label": "Загрузка контейнера",
            "value": ""
          }
        ]
      },
      "p8": {
        "name": "Серия 23W",
        "description": "Тонкий обогреватель дальнего инфракрасного диапазона с приложением Tuya Smart WiFi, голосовым управлением, пультом дистанционного управления и таймером для внутренних помещений и крытых патио.",
        "longDescription": "Серия 23W сочетает тонкую черную панель с нанопокрытием, приложение Tuya Smart WiFi и совместимые голосовые команды. Пульт обеспечивает четыре уровня мощности и таймер 0/2/4/6/8 часов. Монтаж — на подходящей стене в помещении или крытой зоне с кронштейнами и зазорами модели.",
        "category": "Инфракрасный обогреватель",
        "features": [
          "Смарт-приложение Туя",
          "Голосовое управление",
          "Пульт дистанционного управления",
          "Функция таймера",
          "4 уровня мощности",
          "Быстрый нагрев"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "NR10/18/24/32-23W"
          },
          {
            "label": "Мощность",
            "value": "1.0/1.8/2.4/3.2 kW"
          },
          {
            "label": "Площадь покрытия",
            "value": "10/20/30/40 m²"
          },
          {
            "label": "Напряжение/частота",
            "value": "220-240V~50/60Hz"
          },
          {
            "label": "Номинальный ток",
            "value": "4.3/7.8/10.4/13.9A"
          },
          {
            "label": "Температура поверхности",
            "value": "300°C"
          },
          {
            "label": "Размерность",
            "value": "693/1093/1593/2093 × 151 × 52 mm"
          },
          {
            "label": "Н/Г Вес",
            "value": "3.4/4.2; 5.3/6.4; 7.6/9.5; 9.9/12.5 kg"
          },
          {
            "label": "Загрузка контейнера",
            "value": "1248; 800; 528; 412 (20HQ)"
          }
        ]
      },
      "p20": {
        "name": "Серия 23A",
        "description": "Тонкий обогреватель дальнего инфракрасного диапазона с обычным пультом дистанционного управления, таймером и 4 уровнями мощности — без необходимости использования Wi-Fi или приложения.",
        "longDescription": "Серия 23A — это тонкий обогреватель дальнего инфракрасного диапазона, управляемый с помощью обычного портативного пульта дистанционного управления без подключения к Wi-Fi или приложению. Пульт дистанционного управления обеспечивает 4 уровня мощности (25%/50%/75%/100%) и таймер на 0/2/4/6/8 часов. Его гладкая черная панель с нанопокрытием обеспечивает быстрое, равномерное, бесшумное и беспламенное излучение тепла. Доступны мощности от 1000 Вт до 3200 Вт для помещений площадью 10–40 м², с компактным профилем толщиной 52 мм, подходящим для домов, ресторанов, офисов и крытых террас.",
        "category": "Инфракрасный обогреватель",
        "features": [
          "Пульт дистанционного управления",
          "Функция таймера",
          "4 уровня мощности",
          "Тонкий дизайн",
          "Быстрый нагрев",
          "Тихая работа"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": ""
          },
          {
            "label": "Мощность",
            "value": ""
          },
          {
            "label": "Площадь покрытия",
            "value": ""
          },
          {
            "label": "Напряжение/частота",
            "value": ""
          },
          {
            "label": "Номинальный ток",
            "value": ""
          },
          {
            "label": "Температура поверхности",
            "value": ""
          },
          {
            "label": "Размерность",
            "value": ""
          },
          {
            "label": "Н/Г Вес",
            "value": ""
          },
          {
            "label": "Загрузка контейнера",
            "value": ""
          }
        ]
      },
      "p21": {
        "name": "Серия 25W",
        "description": "Настенный обогреватель дальнего инфракрасного диапазона со встроенным Wi-Fi, управлением через приложение Tuya, LED-дисплеем уровня и четырьмя уровнями мощности от 1000 до 3200 Вт.",
        "longDescription": "Серия 25W — это тонкий настенный обогреватель дальнего инфракрасного диапазона со встроенным модулем Wi-Fi для управления через приложение Tuya Smart: включайте панель, меняйте уровень мощности и задавайте расписание с телефона либо используйте беспроводной пульт из комплекта с кнопкой сопряжения Wi-Fi. Красный LED-дисплей на блоке управления показывает текущий уровень мощности. Четыре уровня мощности охватывают от 1000 до 3200 Вт и помещения от 10 до 40 м², а все модели используют одинаковый алюминиевый корпус толщиной 67 мм. Спиральный нагревательный элемент дальнего инфракрасного излучения проходит по всей длине панели внутри корпуса из экструдированного алюминия и доводит ребристую алюминиевую поверхность до 300 °C.",
        "category": "Инфракрасный обогреватель",
        "features": [
          "Wi-Fi приложение Tuya",
          "LED-дисплей уровня",
          "Беспроводной пульт",
          "4 уровня мощности",
          "Поверхность 300 °C",
          "Корпус 67 мм"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "NR10/18/24/32-25W"
          },
          {
            "label": "Мощность",
            "value": "1.0/1.8/2.4/3.2 kW"
          },
          {
            "label": "Площадь покрытия",
            "value": "10/20/30/40 m²"
          },
          {
            "label": "Напряжение/частота",
            "value": "220-240V~50/60Hz"
          },
          {
            "label": "Номинальный ток",
            "value": "4.3/7.8/10.4/13.9A"
          },
          {
            "label": "Температура поверхности",
            "value": "300°C"
          },
          {
            "label": "Размерность",
            "value": "715/1115/1615/2115 × 189 × 67 mm"
          },
          {
            "label": "Н/Г Вес",
            "value": "4.4/5.5; 6.9/8.1; 9.5/11.3; 12.3/14.3 kg"
          },
          {
            "label": "Загрузка контейнера",
            "value": "945/1920/2176; 615/1290/1462; 435/885/1003; 345/705/799"
          }
        ]
      },
      "p9": {
        "name": "JHL020A",
        "description": "Компактный обогреватель из углеродного волокна с защитой от опрокидывания. Идеально подходит для индивидуального обогрева под партами или столами.",
        "longDescription": "JHL020A — компактный и эффективный обогреватель под столом, предназначенный для индивидуального обогрева. Оснащен нагревательной трубкой из углеродного волокна для быстрого и равномерного распределения тепла. Оснащен кулисным переключателем управления и защитой от опрокидывания для обеспечения безопасности. Прохладная сетчатая конструкция предотвращает случайные ожоги и обеспечивает эффективное тепло. Легкая конструкция с вилкой европейского стандарта делает его идеальным для использования дома или в офисе.",
        "category": "Портативный обогреватель",
        "features": [
          "Защита от опрокидывания",
          "Прохладная сетка",
          "Компактный дизайн",
          "Быстрый нагрев",
          "Энергоэффективный"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "JHL020A"
          },
          {
            "label": "Название продукта",
            "value": "Под настольным обогревателем"
          },
          {
            "label": "Напряжение",
            "value": "220-240V~50Hz"
          },
          {
            "label": "Мощность",
            "value": "1200W"
          },
          {
            "label": "Контроль",
            "value": "Кулисный переключатель"
          },
          {
            "label": "Нагревательный элемент",
            "value": "1 нагревательная трубка из углеродного волокна"
          },
          {
            "label": "Вилка",
            "value": "ЕС-вилка"
          },
          {
            "label": "Кабель",
            "value": "1.8-1.9m"
          },
          {
            "label": "Материал",
            "value": "Железо, Алюминий"
          }
        ]
      },
      "p10": {
        "name": "JHL023",
        "description": "Мощный обогреватель из углеродного волокна с двумя режимами нагрева и складной ручкой. Портативное решение для отопления любого помещения.",
        "longDescription": "JHL023 — это мощный портативный отдельно стоящий обогреватель с двойными нагревательными трубками из углеродного волокна для эффективного обогрева. Два режима нагрева (750 Вт + 750 Вт) позволяют гибко регулировать температуру. Поворотный переключатель обеспечивает простоту эксплуатации, а складная ручка делает его очень портативным. Этот обогреватель, изготовленный из прочного пластика и стали, идеально подходит для гостиных, спален, офисов или любого помещения, где требуется дополнительное тепло.",
        "category": "Портативный обогреватель",
        "features": [
          "Двойные настройки нагрева",
          "Складная ручка",
          "Отопление из углеродного волокна",
          "Портативный дизайн",
          "Простое управление"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "JHL023"
          },
          {
            "label": "Название продукта",
            "value": "Отдельностоящий обогреватель"
          },
          {
            "label": "Напряжение",
            "value": "220-240V~50Hz"
          },
          {
            "label": "Мощность",
            "value": "1500 Вт (макс.)"
          },
          {
            "label": "Настройки",
            "value": "750W + 750W"
          },
          {
            "label": "Контроль",
            "value": "Поворотный переключатель"
          },
          {
            "label": "Нагревательный элемент",
            "value": "Нагревательная трубка из углеродного волокна x 2"
          },
          {
            "label": "Вилка",
            "value": "ЕС вилка"
          },
          {
            "label": "Кабель",
            "value": "1.8-1.9m"
          },
          {
            "label": "Материал",
            "value": "Пластик, Сталь"
          },
          {
            "label": "Особенность",
            "value": "Складная ручка"
          }
        ]
      },
      "p11": {
        "name": "JHL023-05",
        "description": "Компактный обогреватель из углеродного волокна с двумя настройками нагрева. Энергоэффективное отопление для небольших и средних помещений.",
        "longDescription": "JHL023-05 — это компактный и энергоэффективный отдельно стоящий обогреватель, идеально подходящий для небольших и средних помещений. Благодаря двойным нагревательным трубкам из углеродного волокна с двумя регулируемыми настройками (400 Вт + 400 Вт) он обеспечивает комфортное тепло и экономит энергию. Поворотный переключатель упрощает работу, а складная ручка обеспечивает удобное хранение и портативность. Идеально подходит для спален, домашних офисов или личных рабочих мест.",
        "category": "Портативный обогреватель",
        "features": [
          "Двойные настройки нагрева",
          "Складная ручка",
          "Отопление из углеродного волокна",
          "Компактный и портативный",
          "Энергоэффективный"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "JHL023-05"
          },
          {
            "label": "Название продукта",
            "value": "Отдельностоящий обогреватель"
          },
          {
            "label": "Напряжение",
            "value": "220-240V~50Hz"
          },
          {
            "label": "Мощность",
            "value": "800 Вт (макс.)"
          },
          {
            "label": "Настройки",
            "value": "400W + 400W"
          },
          {
            "label": "Контроль",
            "value": "Поворотный переключатель"
          },
          {
            "label": "Нагревательный элемент",
            "value": "Нагревательная трубка из углеродного волокна x 2"
          },
          {
            "label": "Вилка",
            "value": "ЕС вилка"
          },
          {
            "label": "Кабель",
            "value": "1.8-1.9m"
          },
          {
            "label": "Материал",
            "value": "Пластик, Сталь"
          },
          {
            "label": "Особенность",
            "value": "Складная ручка"
          }
        ]
      },
      "p12": {
        "name": "JHL021-S",
        "description": "Универсальный обогреватель со светодиодной подсветкой и динамиком Bluetooth. Идеально подходит для создания уютной атмосферы.",
        "longDescription": "JHL021-S — это инновационный обогреватель, сочетающий в себе функцию обогрева и развлекательные функции. Оснащен 16-цветной светодиодной подсветкой, создающей идеальную атмосферу в любой обстановке. Оснащен динамиком Bluetooth для потоковой передачи музыки с мобильного устройства. Кулисный переключатель управляет настройками нагрева, а пульт дистанционного управления управляет функциями Bluetooth и светодиодной подсветки. Имеет защиту от опрокидывания для безопасности и сетку CoolTouch для предотвращения ожогов. Нагревательная трубка из углеродного волокна обеспечивает эффективный и быстрый нагрев. Идеально подходит для гостиных, спален или любого внутреннего помещения, где вам хочется тепла и атмосферы.",
        "category": "Портативный обогреватель",
        "features": [
          "16-цветный светодиодный светильник",
          "Bluetooth-динамик",
          "Защита от опрокидывания",
          "Сетка CoolTouch",
          "Пульт дистанционного управления"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "JHL021-S"
          },
          {
            "label": "Название продукта",
            "value": "Светодиодный Bluetooth-нагреватель"
          },
          {
            "label": "Напряжение",
            "value": "220-240V~50Hz"
          },
          {
            "label": "Мощность",
            "value": "1500W"
          },
          {
            "label": "Контроль",
            "value": "Кулисный переключатель (нагрев), пульт дистанционного управления (BT и светодиод)"
          },
          {
            "label": "светодиод",
            "value": "16-цветный свет"
          },
          {
            "label": "Нагревательный элемент",
            "value": "1 нагревательная трубка из углеродного волокна"
          },
          {
            "label": "Вилка",
            "value": "ЕС-вилка"
          },
          {
            "label": "Кабель",
            "value": "1.8-1.9m"
          },
          {
            "label": "Безопасность",
            "value": "Защита от опрокидывания, CoolTouch Mesh."
          },
          {
            "label": "Материал",
            "value": "Железо, Алюминий"
          }
        ]
      },
      "p13": {
        "name": "JHL004-B",
        "description": "Мощный галогенный обогреватель мощностью 3000 Вт с телескопической стойкой. Регулируемая высота для индивидуального обогрева.",
        "longDescription": "JHL004-B — это мощный отдельно стоящий обогреватель для террасы, предназначенный для использования на открытом воздухе и в полуоткрытом помещении. Имеет две галогенные нагревательные трубки, обеспечивающие эффективное и комфортное тепло, с тремя регулируемыми настройками мощности (1200–1800–3000 Вт). Телескопическая опора позволяет регулировать высоту от 1,6 м до 2,08 м, что позволяет настроить обогрев различных зон. Оснащен дистанционным управлением и сенсорной кнопкой для удобного управления. Для безопасности предусмотрена защита от опрокидывания. Современный дизайн из железа и алюминия обеспечивает долговечность, сохраняя при этом элегантный внешний вид. Идеально подходит для патио, террас, садов и развлекательных зон на открытом воздухе.",
        "category": "Портативный обогреватель",
        "features": [
          "Высокая мощность 3000 Вт",
          "Телескопическая стойка",
          "3 режима нагрева",
          "Дистанционное и сенсорное управление",
          "Защита от опрокидывания"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "JHL004-B"
          },
          {
            "label": "Название продукта",
            "value": "Отдельностоящий обогреватель для патио"
          },
          {
            "label": "Напряжение",
            "value": "220-240V~50Hz"
          },
          {
            "label": "Мощность",
            "value": "3000 Вт (макс.)"
          },
          {
            "label": "Настройки",
            "value": "1200W-1800W-3000W"
          },
          {
            "label": "Контроль",
            "value": "Пульт и сенсорная кнопка"
          },
          {
            "label": "Высота",
            "value": "Телескопическая стойка (1,6–2,08 м)"
          },
          {
            "label": "Нагревательный элемент",
            "value": "2 галогенные нагревательные трубки"
          },
          {
            "label": "Вилка",
            "value": "ЕС-вилка"
          },
          {
            "label": "Кабель",
            "value": "1.8-1.9m"
          },
          {
            "label": "Безопасность",
            "value": "Защита от опрокидывания"
          },
          {
            "label": "Материал",
            "value": "Железо, Алюминий"
          }
        ]
      },
      "p14": {
        "name": "JHL001-BZ",
        "description": "Эффективный галогенный обогреватель для террасы с фиксированной опорой. Чистое и стильное решение для обогрева открытых пространств.",
        "longDescription": "JHL001-BZ — это элегантный и эффективный обогреватель для террасы с фиксированной опорой. Оснащен двумя галогенными нагревательными трубками, обеспечивающими три регулируемых уровня мощности (900–1200–2100 Вт) для комфортного тепла. Обтянутый тканью дизайн придает стильный вид, сохраняя при этом функциональность. И пульт дистанционного управления, и сенсорная кнопка обеспечивают простоту управления. Имеет защиту от опрокидывания для безопасности во время использования. Сочетание железа и алюминия обеспечивает долговечность и эффективное распределение тепла. Идеально подходит для крытых патио, беседок и других полуоткрытых помещений, где стиль и тепло одинаково важны.",
        "category": "Портативный обогреватель",
        "features": [
          "3 режима нагрева",
          "Дизайн ткани",
          "Дистанционное и сенсорное управление",
          "Защита от опрокидывания",
          "Эффективное галогенное отопление"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "JHL001-BZ"
          },
          {
            "label": "Название продукта",
            "value": "Тканевый обогреватель для патио"
          },
          {
            "label": "Напряжение",
            "value": "220-240V~50Hz"
          },
          {
            "label": "Мощность",
            "value": "2100 Вт (макс.)"
          },
          {
            "label": "Настройки",
            "value": "900W-1200W-2100W"
          },
          {
            "label": "Контроль",
            "value": "Пульт и сенсорная кнопка"
          },
          {
            "label": "Высота",
            "value": "Фиксированный столб"
          },
          {
            "label": "Нагревательный элемент",
            "value": "2 галогенные нагревательные трубки"
          },
          {
            "label": "Вилка",
            "value": "ЕС-вилка"
          },
          {
            "label": "Кабель",
            "value": "1.8-1.9m"
          },
          {
            "label": "Безопасность",
            "value": "Защита от опрокидывания"
          },
          {
            "label": "Материал",
            "value": "Железо, Алюминий"
          }
        ]
      },
      "p15": {
        "name": "JHD028-B",
        "description": "Мощный потолочный галогенный обогреватель мощностью 2000 Вт с тремя режимами нагрева. Идеально подходит для помещений с высокими потолками.",
        "longDescription": "JHD028-B — это потолочный обогреватель, предназначенный для эффективного обогрева внутренних помещений. Имеет две галогенные нагревательные трубки, обеспечивающие мощный и равномерный нагрев с тремя регулируемыми настройками (800–1200–2000 Вт). Потолочная установка экономит пространство и обеспечивает отличное распределение тепла сверху. Оснащен дистанционным управлением и сенсорной кнопкой для удобного управления. Конструкция из алюминия и железа обеспечивает долговечность и эффективную теплопроводность. Идеально подходит для помещений с высокими потолками, мастерских, гаражей или любых помещений, где предпочтительным является потолочный монтаж. Обеспечивает постоянное и комфортное тепло, не занимая при этом места на полу.",
        "category": "Портативный обогреватель",
        "features": [
          "Потолочный монтаж",
          "2 галогенные трубки",
          "3 режима нагрева",
          "Дистанционное и сенсорное управление",
          "Экономия места"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "JHD028-B"
          },
          {
            "label": "Название продукта",
            "value": "Потолочный обогреватель"
          },
          {
            "label": "Напряжение",
            "value": "220-240V~50Hz"
          },
          {
            "label": "Мощность",
            "value": "2000 Вт (макс.)"
          },
          {
            "label": "Настройки",
            "value": "800W-1200W-2000W"
          },
          {
            "label": "Контроль",
            "value": "Пульт и сенсорная кнопка"
          },
          {
            "label": "Нагревательный элемент",
            "value": "2 галогенные нагревательные трубки"
          },
          {
            "label": "Вилка",
            "value": "ЕС-вилка"
          },
          {
            "label": "Кабель",
            "value": "1.8-1.9m"
          },
          {
            "label": "Материал",
            "value": "Алюминий, Железо"
          }
        ]
      },
      "p16": {
        "name": "JHG019-B",
        "description": "Умный угольный обогреватель с функцией таймера. Настенная конструкция экономит пространство и обеспечивает мощное тепло.",
        "longDescription": "JHG019-B — это умный настенный обогреватель для террасы, в котором используется передовая технология нагрева из углеродного волокна. Обеспечивает мощное и эффективное тепло благодаря трем регулируемым настройкам (650–1300–2000 Вт). Имеет несколько вариантов управления, включая кулисный переключатель, пульт дистанционного управления и сенсорную кнопку для максимального удобства. Встроенная функция таймера обеспечивает автоматическое отключение на срок до 8 часов, обеспечивая экономию энергии и душевное спокойствие. Карбоновая нагревательная трубка обеспечивает быстрый нагрев с отличным распределением тепла. Настенная конструкция экономит ценное пространство на полу, обеспечивая при этом мощное тепло. Изготовлен из прочной конструкции из железа и алюминия. Идеально подходит для патио, гаражей, мастерских или любого внутреннего или наружного пространства, где предпочтительным является настенный монтаж.",
        "category": "Портативный обогреватель",
        "features": [
          "Настенный",
          "Углеродное отопление",
          "8-часовой таймер",
          "Несколько вариантов управления",
          "Компактный дизайн"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "JHG019-B"
          },
          {
            "label": "Название продукта",
            "value": "Настенный обогреватель для патио"
          },
          {
            "label": "Напряжение",
            "value": "220-240V~50Hz"
          },
          {
            "label": "Мощность",
            "value": "2000 Вт (макс.)"
          },
          {
            "label": "Настройки",
            "value": "650W-1300W-2000W"
          },
          {
            "label": "Переключатель",
            "value": "Кулисный переключатель, дистанционное и сенсорное управление"
          },
          {
            "label": "Удаленный",
            "value": "Да"
          },
          {
            "label": "Таймер",
            "value": "Да, до 8 часов"
          },
          {
            "label": "Нагревательный элемент",
            "value": "Углеродная нагревательная трубка"
          },
          {
            "label": "Вилка",
            "value": "ЕС-вилка"
          },
          {
            "label": "Кабель",
            "value": "1.8-1.9m"
          },
          {
            "label": "Материал",
            "value": "Железо, Алюминий"
          }
        ]
      },
      "p17": {
        "name": "JH-104",
        "description": "Эффективный настенный обогреватель с галогенной трубкой цвета рубина и золота. Компактный дизайн идеально подходит для внутренних помещений.",
        "longDescription": "JH-104 — эффективный настенный обогреватель, предназначенный для внутренних помещений. Имеет рубиново-золото-галогеновую трубку, обеспечивающую быстрый и эффективный нагрев. Компактный дизайн с тремя регулируемыми режимами нагрева (800 Вт/1300 Вт/2000 Вт) позволяет настроить уровень комфорта. Оснащен дистанционным управлением для удобного управления. Изящный дизайн идеально впишется в любую комнату, обеспечивая при этом мощное тепло. Идеально подходит для гостиных, спален, офисов или любых помещений, где предпочтительным является настенный монтаж.",
        "category": "Портативный обогреватель",
        "features": [
          "Настенный",
          "Галогенная трубка из рубинового золота",
          "3 режима нагрева",
          "Пульт дистанционного управления",
          "Компактный дизайн"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "JH-104"
          },
          {
            "label": "Название продукта",
            "value": "Настенный обогреватель"
          },
          {
            "label": "Напряжение",
            "value": "220V ~ 50Hz"
          },
          {
            "label": "Мощность",
            "value": "2000 Вт (макс.)"
          },
          {
            "label": "Настройки",
            "value": "800W / 1300W / 2000W"
          },
          {
            "label": "Контроль",
            "value": "Пульт дистанционного управления"
          },
          {
            "label": "Нагревательный элемент",
            "value": "Галогенная трубка из рубинового золота"
          },
          {
            "label": "Вилка",
            "value": "ЕС вилка"
          },
          {
            "label": "Кабель",
            "value": "3m"
          },
          {
            "label": "Размеры",
            "value": "63.5cm × 10cm"
          },
          {
            "label": "Вес",
            "value": "2.2kg"
          }
        ]
      },
      "p18": {
        "name": "JH-106",
        "description": "Компактный потолочный обогреватель с технологией углеродного волокна. Идеально подходит для небольших помещений.",
        "longDescription": "JH-106 — компактный потолочный обогреватель, предназначенный для эффективного обогрева небольших помещений. Технология нагревательных трубок из углеродного волокна обеспечивает быстрый и эффективный нагрев. Шнурковый переключатель обеспечивает легкое включение/выключение. Три регулируемых режима нагрева (600 Вт/1000 Вт/1500 Вт) позволяют настроить уровень комфорта. Потолочный монтаж экономит пространство и обеспечивает превосходное распределение тепла. Идеально подходит для небольших комнат, ванных комнат, кухонь или любого помещения, где предпочтительным является потолочный монтаж.",
        "category": "Портативный обогреватель",
        "features": [
          "Потолочный монтаж",
          "Технология углеродного волокна",
          "3 режима нагрева",
          "Шнурковый переключатель",
          "Экономия места"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "JH-106"
          },
          {
            "label": "Название продукта",
            "value": "Потолочный обогреватель"
          },
          {
            "label": "Напряжение",
            "value": "220V ~ 50Hz"
          },
          {
            "label": "Мощность",
            "value": "1500 Вт (макс.)"
          },
          {
            "label": "Настройки",
            "value": "600W / 1000W / 1500W"
          },
          {
            "label": "Контроль",
            "value": "Шнурковый переключатель"
          },
          {
            "label": "Нагревательный элемент",
            "value": "Нагревательная трубка из углеродного волокна"
          },
          {
            "label": "Вилка",
            "value": "ЕС вилка"
          },
          {
            "label": "Кабель",
            "value": "3m"
          },
          {
            "label": "Размеры",
            "value": "42 см (диаметр) × 30 см (высота)"
          },
          {
            "label": "Вес",
            "value": "2.3kg"
          }
        ]
      },
      "p19": {
        "name": "JH-3000",
        "description": "Регулируемый обогреватель для террасы премиум-класса с управлением через приложение для смартфона. Идеально подходит для развлечений на свежем воздухе.",
        "longDescription": "JH-3000 — это регулируемый обогреватель премиум-класса для террасы, предназначенный для развлечений на открытом воздухе. Оснащен передовой технологией нагревательных трубок из углеродного волокна для мощного и эффективного обогрева. Регулируемая высота (160-205 см) позволяет настроить зону обогрева. Оснащен дистанционным управлением и приложением для смартфона для максимального удобства. Три регулируемых режима нагрева (1200 Вт/1800 Вт/3000 Вт) обеспечивают индивидуальный комфорт. Прочное основание диаметром 45 см обеспечивает устойчивость. Идеально подходит для патио, террас, садов и развлекательных зон на открытом воздухе.",
        "category": "Портативный обогреватель",
        "features": [
          "Регулируемая высота",
          "Отопление из углеродного волокна",
          "3 режима нагрева",
          "Управление через приложение для смартфона",
          "Пульт дистанционного управления"
        ],
        "specs": [
          {
            "label": "Модель",
            "value": "JH-3000"
          },
          {
            "label": "Название продукта",
            "value": "Регулируемый обогреватель для патио Black Umbrella"
          },
          {
            "label": "Напряжение",
            "value": "220V ~ 50Hz"
          },
          {
            "label": "Мощность",
            "value": "3000 Вт (макс.)"
          },
          {
            "label": "Настройки",
            "value": "1200W / 1800W / 3000W"
          },
          {
            "label": "Контроль",
            "value": "Пульт дистанционного управления и приложение для смартфона"
          },
          {
            "label": "Нагревательный элемент",
            "value": "Нагревательная трубка из углеродного волокна"
          },
          {
            "label": "Вилка",
            "value": "ЕС вилка"
          },
          {
            "label": "Кабель",
            "value": "5m"
          },
          {
            "label": "Высота",
            "value": "Регулируемый, 160-205 см"
          },
          {
            "label": "Базовый диаметр",
            "value": "45cm"
          },
          {
            "label": "Вес",
            "value": "12kg"
          }
        ]
      }
    }
  },
  "technology": {
    "title": "Как работают инфракрасные обогреватели",
    "subtitle": "Узнайте, как технология дальнего инфракрасного отопления обеспечивает более эффективное и комфортное тепло — и почему это безопаснее и полезнее для здоровья, чем традиционное конвекционное отопление.",
    "section1": {
      "title": "Солнечное тепло во всей комнате",
      "desc1": "Традиционные конвекционные обогреватели сначала нагревают воздух. Горячий воздух поднимается к потолку, оставляя холодные пятна у пола, поднимая пыль и высушивая помещение. Именно поэтому многие задаются вопросом: лучше ли инфракрасные обогреватели, чем конвекционные?",
      "desc2": "Инфракрасные обогреватели работают по совершенно другому принципу. Подобно солнечному свету, они излучают невидимые электромагнитные волны, которые непосредственно нагревают предметы, стены и людей, а не воздух. Поверхности поглощают это лучистое тепло и постепенно отдают его, сохраняя равномерное тепло во всем пространстве. Таким образом, инфракрасные обогреватели достигают эффективности преобразования энергии до 99%, потребляя при этом на 80% меньше электроэнергии, чем традиционное отопление.",
      "radiant": "Лучистая теплопередача"
    },
    "section2": {
      "title": "Технология нагрева ядра",
      "intro": "Наш специально разработанный нагревательный элемент в сочетании с запатентованным нанокерамическим покрытием обеспечивает исключительную эффективность нагрева. Это технология, лежащая в основе наших энергоэффективных инфракрасных обогревателей, которым доверяют более чем в 80 странах.",
      "surface": "Нано-керамическое покрытие",
      "surfaceDesc": "Наше запатентованное нанокерамическое покрытие значительно увеличивает площадь излучающей поверхности с коэффициентом излучения до 86%. Это означает большую теплоотдачу на ватт — ключ к нашей энергоэффективной конструкции.",
      "rapid": "Быстрая разминка",
      "rapidDesc": "Алюминий с высокой проводимостью достигает идеальной температуры всего за 5 минут. Больше не нужно ждать, пока комната прогреется — мгновенное лучистое тепло, когда оно вам нужно.",
      "durability": "Ультра-долгий срок службы",
      "durabilityDesc": "Рассчитан на более чем 25 лет работы без технического обслуживания. Наши инфракрасные нагревательные элементы рассчитаны на длительный срок службы, что снижает затраты на замену и вред для окружающей среды.",
      "nanoTitle": "Нано-керамическая технология"
    },
    "infraredIntroduction": {
      "title": "Передовая технология дальнего инфракрасного диапазона",
      "desc": "Как именно работает инфракрасный обогреватель? Используя дальнюю инфракрасную часть электромагнитного спектра (длина волны 8–15 мкм), наши обогреватели достигают выдающейся тепловой эффективности. Эта длина волны специально оптимизирована таким образом, чтобы человеческое тело наиболее эффективно поглощало тепло — подобно тому, как солнце согревает вас в прохладный день.",
      "optimalWavelength": "Оптимальная длина волны для человеческого тела",
      "optimalWavelengthDesc": "Настроен на полосу частот 8–15 мкм, которая естественным образом резонирует с молекулами воды в организме. Вот почему тепло в дальнем инфракрасном диапазоне кажется таким естественным и комфортным — это та же длина волны, которую излучает само человеческое тело.",
      "superiorEfficiency": "Превосходная энергоэффективность",
      "superiorEfficiencyDesc": "Являются ли инфракрасные обогреватели энергоэффективными? Да, дальний инфракрасный диапазон превосходит ближний и средний инфракрасный диапазон по эффективности обогрева. Он обеспечивает мягкое, равномерное тепло, не обжигая и не высушивая воздух. Наши обогреватели преобразуют до 99% электроэнергии в полезное тепло.",
      "radiantEnergy": "Прямое лучистое тепло, ноль отходов",
      "radiantEnergyDesc": "В отличие от конвекционных обогревателей, которые тратят энергию на нагрев воздуха, поднимающегося к потолку, инфракрасные обогреватели излучают чистое лучистое тепло непосредственно людям и предметам. Отсутствие циркуляции воздуха означает отсутствие потерь энергии, пыли и распространения аллергенов."
    },
    "healthBenefits": {
      "title": "Помимо отопления: польза инфракрасных обогревателей для здоровья",
      "desc": "Полезны ли инфракрасные обогреватели? Дальний инфракрасный диапазон не только согревает вас. Его уникальная длина волны обеспечивает доказанную пользу для здоровья, что делает его более здоровой альтернативой традиционным конвекционным и принудительным системам отопления.",
      "card1": {
        "title": "«Свет жизни»",
        "desc": "Работая в диапазоне 8–15 мкм, это тепло естественным образом соответствует собственной частоте вашего тела. Дальний инфракрасный диапазон — это та же полезная энергия, которая используется в сауне и физиотерапии. В результате получается нежное тепло, которое глубоко впитывается и ощущается совершенно естественно — безопасно для использования в течение всего дня."
      },
      "card2": {
        "title": "Чистое, легкое дыхание",
        "desc": "Безопасны ли инфракрасные обогреватели для использования в помещении? В отличие от традиционных конвекционных обогревателей, инфракрасные обогреватели не выдувают воздух, не разносят пыль и не пересушивают помещение. Это делает их идеальными для людей, страдающих аллергией, астмой или чувствительностью дыхательных путей. Отсутствие вентиляторов означает отсутствие шума и частиц в воздухе."
      },
      "card3": {
        "title": "Глубокое, успокаивающее тепло",
        "desc": "Тепловые волны дальнего инфракрасного диапазона проникают глубоко в кожу, поддерживая микроциркуляцию, успокаивая мышцы и уменьшая зимнюю скованность. По такому же принципу работают инфракрасные физиотерапевтические лампы, используемые в больницах и спортивной медицине."
      }
    }
  },
  "about": {
    "title": "О нас",
    "subtitle": "Ваш надежный производитель и поставщик инфракрасных обогревателей из Китая.",
    "header": {
      "title": "О JH Heatsup",
      "subtitle": "Ваш надежный производитель и поставщик инфракрасных обогревателей из Китая."
    },
    "history": {
      "title": "Наша история",
      "desc": "Основанная в 2006 году компания Fujian Jinghui Environmental Technology Co., Ltd. (JH Heatsup) является ведущим производителем инфракрасных обогревателей в Китае. Начав с простой идеи — создавать мощные, энергоэффективные и экологически ответственные решения для отопления — мы превратились из небольшой команды исследователей и разработчиков в мирового производителя, экспортирующего продукцию в более чем 80 стран.",
      "timelineTitle": "Этапы развития инфракрасного отопления",
      "timelineDesc": "Шесть ключевых этапов — от первых серий дальнего инфракрасного диапазона до подключенных решений и быстрого обогрева ванных комнат.",
      "milestones": [
        { "year": "2013", "title": "Начало производства ИК-обогревателей", "desc": "Серии инфракрасных излучающих обогревателей 13A и 13B запущены в производство." },
        { "year": "2015", "title": "Расширение линейки", "desc": "Выпущены серии инфракрасных обогревателей 14A/14B и 15A/15B." },
        { "year": "2017", "title": "Отопление с Bluetooth", "desc": "Серия JH13C вышла на рынок со встроенным Bluetooth-динамиком." },
        { "year": "2018", "title": "Решения для новых пространств", "desc": "На рынок вышли плинтусные обогреватели, началось производство инфракрасных обогревателей для ванных комнат." },
        { "year": "2019", "title": "Умное отопление с Wi-Fi", "desc": "Подключенная серия 13W выпущена со встроенной функцией Wi-Fi." },
        { "year": "2021", "title": "Тепло за пять секунд", "desc": "Разработан стеклянный панельный обогреватель для ванной комнаты с нагревом за пять секунд." }
      ]
    },
    "mission": {
      "title": "Наша миссия"
    },
    "quality": {
      "title": "Гарантия качества",
      "desc": "Производственные процессы сертифицированы по стандарту ISO9001. Каждый инфракрасный обогреватель проходит строгие испытания перед отправкой с нашего завода, что обеспечивает стабильное качество оптовых и OEM-заказов."
    },
    "values": {
      "title": "Наши основные ценности",
      "sustainability": {
        "title": "Устойчивое развитие и инновации",
        "desc": "Наши инфракрасные обогреватели потребляют на 80 % меньше энергии, чем традиционные конвекционные обогреватели. Мы постоянно внедряем инновационные энергосберегающие технологии, чтобы снизить выбросы углекислого газа и максимально повысить эффективность отопления."
      },
      "quality": {
        "title": "Сертифицированное качество",
        "desc": "Создан на объектах, сертифицированных по стандарту ISO9001, и протестирован на соответствие международным стандартам, включая CE, CB, SAA и RoHS. Каждый продукт отвечает самым строгим требованиям безопасности и производительности."
      },
      "customerFirst": {
        "title": "Глобальное доверие и партнерство",
        "desc": "Нам доверяют более 800 партнеров по всему миру в более чем 80 странах в качестве поставщика инфракрасных обогревателей. Мы строим долгосрочные отношения посредством надежного обслуживания OEM/ODM, своевременной доставки и поддержки клиентов."
      }
    },
    "features": {
      "title": "Почему стоит выбрать наши инфракрасные обогреватели",
      "fast": {
        "title": "Быстрый нагрев",
        "desc": "Инфракрасные обогреватели достигают полной рабочей температуры всего за 5 минут. Мгновенное сияющее тепло для патио, ресторанов и открытых пространств — без ожидания."
      },
      "energy": {
        "title": "Энергосбережение",
        "desc": "Эффективность преобразования энергии до 99%. Наше интеллектуальное управление через Wi-Fi позволяет сократить расходы на отопление за счет удаленного планирования и регулировки температуры."
      },
      "healthy": {
        "title": "Здоровый комфорт",
        "desc": "Дальнее инфракрасное излучение нагревает людей и предметы напрямую, не высушивая воздух и не распространяя пыль. Безопасен для использования в помещении, не вызывает аллергии и абсолютно бесшумен."
      },
      "safe": {
        "title": "Безопасный и надежный",
        "desc": "Класс водонепроницаемости IPX4, защита от перегрева и переключатели при опрокидывании на портативных моделях. Наши обогреватели безопасны для работы всю ночь и рассчитаны на более чем 25 лет эксплуатации."
      }
    },
    "companyProfile": {
      "title": "Профиль компании",
      "desc": "Fujian Jinghui Environmental Technology Co., Ltd. (JH Heatsup) является профессиональным производителем и поставщиком инфракрасных обогревателей со штаб-квартирой в Фучжоу, Китай. Основанная в 2006 году, мы специализируемся на исследованиях и разработках, производстве и экспорте инфракрасных обогревателей. В наш ассортимент продукции входят настенные инфракрасные панельные обогреватели, портативные обогреватели из углеродного волокна, галогенные обогреватели для террас и потолочные обогреватели — все они предназначены для энергоэффективного, бесшумного и здорового отопления. Мы предлагаем услуги OEM и ODM, поддерживая индивидуальный брендинг, упаковку и разработку продукции для оптовых покупателей по всему миру."
    },
    "services": {
      "title": "Профессиональные услуги",
      "desc": "Как опытный поставщик инфракрасных обогревателей, мы предоставляем комплексную поддержку B2B-партнерам: индивидуальный дизайн продукции, производство OEM/ODM, контроль качества, координацию логистики и послепродажную техническую поддержку. Наши обогреватели предназначены для самых разных применений, включая отопление патио ресторана, отопление складов и мастерских, комфорт офисов и гостиных, отопление тренажерных залов и саун, а также развлекательных зон на открытом воздухе."
    },
    "technology": {
      "title": "Ведущие технологии дальнего инфракрасного диапазона",
      "desc": "Наша запатентованная технология нанокерамического покрытия отличает нас от других производителей инфракрасных обогревателей. Это запатентованное покрытие, нанесенное на наши нагревательные элементы, работающие в дальнем инфракрасном диапазоне, устраняет проблемы обесцвечивания и отслаивания краски, характерные для традиционных обогревателей, одновременно повышая эффективность излучения до 86 %. Результатом является более быстрый нагрев, меньшее потребление энергии и более длительный срок службы продукта.",
      "nanoCeramic": {
        "title": "Нано-керамическая технология",
        "desc": "Запатентованное покрытие с коэффициентом излучения 86% для превосходной эффективности излучения."
      },
      "farInfrared": {
        "title": "Дальнее инфракрасное излучение",
        "desc": "Длина волны 8–15 мкм оптимизирована для поглощения и комфорта человеческого тела."
      }
    },
    "certifications": {
      "title": "Сертификаты и патенты",
      "desc": "Мы обладаем более 32 патентами на внешний вид, полезные модели и изобретения. Наша продукция сертифицирована по международным стандартам: ISO9001:2015, CCC, CE (Европа), CB (международный), SAA (Австралия), EMC и SASO (Саудовская Аравия). Эти сертификаты гарантируют, что наши обогреватели соответствуют требованиям безопасности и качества при импорте на любой рынок по всему миру."
    },
    "clients": {
      "title": "Глобальные клиенты",
      "desc": "Являясь ведущим производителем инфракрасных обогревателей в Китае, наша продукция экспортируется в более чем 80 стран и регионов мира, с сильным присутствием в Европе, Австралии, на Ближнем Востоке и в Юго-Восточной Азии.",
      "export": "Экспорт в более чем 80 стран и регионов.",
      "agents": "Более 800 международных партнеров-дистрибьюторов",
      "trusted": "Надежный поставщик инфракрасных обогревателей с 2006 года.",
      "showcaseTitle": "Нам доверяют партнеры по всему миру",
      "showcaseDesc": "На международных выставках мы лично встречаемся с дистрибьюторами, закупщиками проектов и отраслевыми специалистами со всего мира. Эти встречи помогают нам понимать потребности местных рынков в отоплении, представлять новейшие инфракрасные решения и строить долгосрочные партнерские отношения благодаря надежной продукции, стабильному качеству и оперативной поддержке."
    },
    "manufacturing": {
      "title": "Производственные возможности",
      "desc": "На нашем производственном предприятии площадью 4500 м² работают более 150 технических инженеров и квалифицированных рабочих, которые производят более 10 000 инфракрасных обогревателей в месяц. Нужен ли вам небольшой пробный заказ или полная загрузка контейнера, мы можем доставить товар вовремя и с неизменным качеством. Наши гибкие производственные линии поддерживают как стандартные модели, так и индивидуальные проекты OEM/ODM.",
      "workshopArea": "Зона мастерской",
      "engineersWorkers": "Инженеры и рабочие",
      "monthlyCapacity": "Ежемесячная мощность",
      "patents": "Патенты"
    },
    "ceo": {
      "title": "Наш основатель",
      "name": "г-жа Хуан Сюэфан",
      "role": "Основатель",
      "desc": "Г-жа Хуан Сюэфан — одна из первых исследователей и разработчиков обогревателей дальнего инфракрасного диапазона в Китае. В 2003 году она работала с группой партнеров, увлеченных технологиями отопления, над разработкой испарительных продуктов. В 2006 году она основала компанию Fujian Jinghui Environmental Technology Co., Ltd. В 2011 году она возглавила группу исследований и разработок по разработке панельных излучающих обогревателей дальнего инфракрасного диапазона, став пионером в интеграции интеллектуальных элементов управления Wi-Fi, динамиков Bluetooth и подключения приложений в обогреватели, превратив их из простых приборов в подключенные к сети продукты для образа жизни.",
      "quote": "«Мы стремимся создать более зеленый и теплый мир с помощью технологий»."
    },
    "applications": {
      "title": "Где используются наши инфракрасные обогреватели",
      "desc": "Нашим инфракрасным обогревателям доверяют более чем в 80 странах и они используются в самых разных целях — от патио ресторанов до складских мастерских. Вот наиболее популярные варианты использования.",
      "restaurant": {
        "title": "Ресторан и кафе",
        "desc": "Продлите обеденный сезон на открытом воздухе с помощью энергоэффективных обогревателей для патио.",
        "icon": "Utensils"
      },
      "livingRoom": {
        "title": "Гостиная",
        "desc": "Бесшумное, беспыльное лучистое отопление для комфортной жизни в доме.",
        "icon": "Sofa"
      },
      "office": {
        "title": "Офис",
        "desc": "Зональное отопление, которое сохраняет тепло в рабочих помещениях без потерь на центральное отопление.",
        "icon": "Building"
      },
      "patio": {
        "title": "Патио и на открытом воздухе",
        "desc": "Водонепроницаемые инфракрасные обогреватели для комфорта на открытом воздухе круглый год.",
        "icon": "Sun"
      },
      "sauna": {
        "title": "Сауна и велнес",
        "desc": "Глубоко проникающее инфракрасное излучение для спа- и оздоровительных процедур.",
        "icon": "Flame"
      },
      "garage": {
        "title": "Гараж и Мастерская",
        "desc": "Мощное отопление гаражей, мастерских и складов",
        "icon": "Warehouse"
      },
      "balcony": {
        "title": "Тренажерный зал и фитнес",
        "desc": "Инфракрасное тепло для студий йоги, спортивных залов и фитнес-центров",
        "icon": "Dumbbell"
      },
      "entertainment": {
        "title": "Развлекательная комната",
        "desc": "Уютное обогрев помещения с дополнительной интеграцией динамика Bluetooth",
        "icon": "Gamepad2"
      }
    }
  },
  "contact": {
    "title": "Свяжитесь с нами",
    "subtitle": "Мы хотели бы услышать ваше мнение.",
    "header": {
      "title": "Свяжитесь с нами",
      "subtitle": "Мы хотели бы услышать ваше мнение."
    },
    "form": {
      "firstName": "Имя",
      "lastName": "Фамилия",
      "email": "электронная почта",
      "interested": "Интерес к продукту",
      "selectProduct": "Пожалуйста, выберите",
      "message": "Сообщение",
      "send": "Отправить сообщение",
      "sending": "Отправка..."
    },
    "info": {
      "headquarters": "Штаб-квартира",
      "address": "Здание 25, Научно-технологический парк Ваньян, 26 Tingwang Road, город Тинцзян, район Мавэй, Фучжоу, Фуцзянь, Китай",
      "phoneSupport": "Поддержка по телефону",
      "phone": "+86-15080458735",
      "phoneHours": "Пн-Пт 9:00–18:00 (GMT+8)",
      "emailUs": "Напишите нам",
      "sales": "s3@jinghui-tech.com",
      "support": "s3@jinghui-tech.com",
      "distributor": "Дистрибьюторская сеть",
      "distributorDesc": "Мы ищем глобальных дистрибьюторов. Присоединяйтесь к нам, чтобы принести зеленое отопление в вашу страну."
    },
    "success": {
      "title": "Сообщение отправлено!",
      "desc": "Спасибо, что связались с нами. Наш отдел продаж ответит в течение 24 часов.",
      "sendAnother": "Отправить еще одно сообщение"
    }
  },
  "legal": {
    "privacy": {
      "title": "Политика конфиденциальности",
      "subtitle": "Как мы собираем, используем и защищаем вашу личную информацию.",
      "lastUpdated": "Последнее обновление",
      "effectiveDate": "Дата вступления в силу",
      "meta": {
        "lastUpdatedValue": "6 февраля 2026 г.",
        "effectiveDateValue": "6 февраля 2026 г."
      },
      "introduction": "Компания Fujian Jinghui Environmental Technology Co., Ltd. («мы», «наш» или «нас») обязуется защищать вашу конфиденциальность. В настоящей Политике конфиденциальности объясняется, как мы собираем, используем, раскрываем и защищаем вашу информацию, когда вы посещаете наш веб-сайт и пользуетесь нашими услугами.",
      "sections": {
        "infoCollect": {
          "title": "1. Информация, которую мы собираем",
          "description": "Мы можем собирать личную информацию, которую вы добровольно предоставляете нам, когда вы:",
          "items": [
            "Зарегистрируйтесь на нашем сайте или оставьте заявку",
            "Запросить ценовое предложение или информацию о продукте",
            "Подпишитесь на нашу рассылку",
            "Свяжитесь с нашей командой продаж или поддержки",
            "Участвуйте в опросах или акциях"
          ]
        },
        "typesCollected": {
          "title": "2. Типы собираемой информации",
          "items": [
            "Личная идентификационная информация: имя, адрес электронной почты, номер телефона, название компании, должность.",
            "Демографическая информация: Страна, регион, языковые предпочтения.",
            "Техническая информация: IP-адрес, тип браузера, операционная система, ссылающиеся URL-адреса.",
            "Коммуникационные данные: сообщения, запросы, отзывы и запросы на поддержку."
          ]
        },
        "howUse": {
          "title": "3. Как мы используем вашу информацию",
          "description": "Мы используем информацию, которую собираем, чтобы:",
          "items": [
            "Предоставлять, поддерживать и улучшать наши продукты и услуги",
            "Отвечать на ваши запросы и обеспечивать поддержку клиентов",
            "Отправлять вам информацию о продуктах, расценки и рекламные материалы.",
            "Обработка транзакций и отправка соответствующей информации",
            "Отслеживайте и анализируйте тенденции, использование и действия",
            "Обнаружение, расследование и предотвращение мошеннических транзакций",
            "Соблюдать юридические обязательства"
          ]
        },
        "dataSecurity": {
          "title": "4. Безопасность данных",
          "description": "Мы реализуем соответствующие технические и организационные меры безопасности для защиты вашей личной информации от несанкционированного доступа, изменения, раскрытия или уничтожения. Однако ни один метод передачи через Интернет или электронное хранилище не является на 100% безопасным.",
          "encryption": "Мы используем стандартное шифрование (SSL/TLS) для защиты данных, передаваемых между вашим браузером и нашими серверами."
        },
        "cookies": {
          "title": "5. Файлы cookie и технологии отслеживания",
          "description": "Наш веб-сайт может использовать файлы cookie, веб-маяки и аналогичные технологии отслеживания для сбора информации о вашей активности в Интернете. Вы можете настроить свой браузер так, чтобы он отказывался от всех файлов cookie или указывал на отправку файлов cookie."
        },
        "thirdParty": {
          "title": "6. Раскрытие информации третьим лицам",
          "description": "Мы не продаем, не обмениваем и не передаем иным образом вашу личную информацию сторонним лицам, за исключением следующих обстоятельств:",
          "items": [
            "С поставщиками услуг, которые помогают в наших деловых операциях",
            "Когда этого требует закон, повестка в суд или другой юридический процесс",
            "Чтобы защитить наши права, конфиденциальность, безопасность или собственность",
            "В связи со слиянием, приобретением или продажей активов"
          ]
        },
        "dataRetention": {
          "title": "7. Хранение данных",
          "description": "Мы будем хранить вашу личную информацию столько времени, сколько необходимо для достижения целей, изложенных в настоящей Политике конфиденциальности, если только более длительный период хранения не требуется или не разрешен законом."
        },
        "yourRights": {
          "title": "8. Ваши права",
          "description": "Вы имеете право:",
          "items": [
            "Доступ и получение копии ваших личных данных",
            "Исправить неточные персональные данные",
            "Запросить удаление ваших личных данных",
            "Возражать против обработки ваших персональных данных",
            "Запросить ограничение обработки",
            "Переносимость данных"
          ]
        },
        "children": {
          "title": "9. Конфиденциальность детей",
          "description": "Наш сайт не предназначен для детей до 16 лет. Мы сознательно не собираем личную информацию от детей до 16 лет."
        },
        "international": {
          "title": "10. Международная передача данных",
          "description": "Ваша информация может быть передана и обработана в странах, отличных от страны вашего проживания. В этих странах могут действовать законы о защите данных, отличные от законов вашей страны."
        },
        "changes": {
          "title": "11. Изменения в настоящей Политике",
          "description": "Мы можем время от времени обновлять настоящую Политику конфиденциальности. Мы уведомим вас о любых изменениях, опубликовав новую Политику конфиденциальности на этой странице и обновив дату «Последнего обновления» в верхней части этой политики."
        },
        "contactUs": {
          "title": "12. Свяжитесь с нами",
          "description": "Если у вас есть какие-либо вопросы по поводу настоящей Политики конфиденциальности или наших методов обработки данных, свяжитесь с нами:",
          "email": "электронная почта",
          "address": "Адрес",
          "company": "Компания Fujian Jinghui Environmental Technology Co., Ltd.",
          "addressLine": "Здание 25, Научно-технологический парк Ваньян, 26 Tingwang Road, город Тинцзян, район Мавэй, Фучжоу, Фуцзянь, Китай"
        }
      }
    },
    "terms": {
      "title": "Условия использования",
      "subtitle": "Пожалуйста, внимательно прочтите эти условия перед использованием нашего веб-сайта и услуг.",
      "lastUpdated": "Последнее обновление",
      "effectiveDate": "Дата вступления в силу",
      "meta": {
        "lastUpdatedValue": "6 февраля 2026 г.",
        "effectiveDateValue": "6 февраля 2026 г."
      },
      "introduction": "Добро пожаловать на веб-сайт компании Fujian Jinghui Environmental Technology Co., Ltd. Заходя на этот веб-сайт или используя его, вы соглашаетесь соблюдать настоящие Условия обслуживания, а также все применимые законы и правила. Если вы не согласны с какой-либо частью этих условий, вы не имеете права использовать наш веб-сайт.",
      "importantNotice": {
        "title": "Важное уведомление",
        "description": "Используя этот веб-сайт, вы подтверждаете, что прочитали, поняли и соглашаетесь соблюдать настоящие Условия обслуживания. Если вы используете этот веб-сайт от имени компании или организации, вы заявляете, что имеете полномочия обязать такую ​​организацию соблюдать настоящие условия."
      },
      "sections": {
        "useWebsite": {
          "title": "1. Использование веб-сайта",
          "description": "Этот веб-сайт предоставлен компанией Fujian Jinghui Environmental Technology Co., Ltd. только в информационных целях. Используя этот сайт, вы соглашаетесь:",
          "items": [
            "Используйте сайт только в законных целях и в соответствии с настоящими Условиями.",
            "Не использовать веб-сайт каким-либо образом, который может повредить, вывести из строя, перегрузить или ухудшить его работу.",
            "Не пытайтесь получить несанкционированный доступ к какой-либо части сайта.",
            "Не использовать веб-сайт для передачи вирусов, червей или вредоносного кода.",
            "Уважайте права интеллектуальной собственности JH Heatsup и других."
          ]
        },
        "intellectualProperty": {
          "title": "2. Права интеллектуальной собственности",
          "description": "Весь контент на этом веб-сайте, включая, помимо прочего, текст, графику, логотипы, изображения, аудиоклипы, цифровые загрузки и программное обеспечение, является собственностью Fujian Jinghui Environmental Technology Co., Ltd. или ее поставщиков контента и защищен международными законами об авторских правах, товарных знаках и другими законами об интеллектуальной собственности.",
          "restriction": "Вы не имеете права воспроизводить, распространять, изменять, создавать производные работы, публично демонстрировать, публично исполнять или использовать какой-либо контент с этого веб-сайта без нашего предварительного письменного согласия."
        },
        "productInfo": {
          "title": "3. Информация о продукте и цены.",
          "description": "Все продукты и услуги, представленные на этом сайте, предоставляются в зависимости от наличия. Мы оставляем за собой право прекратить выпуск любого продукта или услуги в любое время.",
          "pricing": "Цены и характеристики могут быть изменены без предварительного уведомления. Мы прилагаем все усилия для обеспечения точности информации о продукте, однако могут возникать ошибки. Мы оставляем за собой право исправлять любые ошибки, неточности или упущения, а также изменять или обновлять информацию в любое время.",
          "currency": "Все цены указаны в долларах США, если не указано иное. Стоимость доставки, налоги и пошлины являются дополнительными и будут рассчитаны в процессе заказа."
        },
        "quotesOrders": {
          "title": "4. Котировки и ордера",
          "description": "Котировки, представленные на этом веб-сайте, действительны в течение 30 дней, если не указано иное. Все заказы подлежат принятию компанией JH Heatsup.",
          "contract": "Отправляя заказ, вы соглашаетесь приобрести продукцию в соответствии с нашими текущими условиями, включая цены, условия доставки и оплаты. Обязательный договор заключается только тогда, когда мы подтверждаем принятие вашего заказа."
        },
        "warranties": {
          "title": "5. Гарантии и отказ от ответственности",
          "description": "ЭТОТ ВЕБ-САЙТ И ВЕСЬ КОНТЕНТ, ПРОДУКТЫ И УСЛУГИ, ПРЕДОСТАВЛЯЕМЫЕ ЧЕРЕЗ НЕГО, ПРЕДОСТАВЛЯЮТСЯ «КАК ЕСТЬ» И «КАК ДОСТУПНО» БЕЗ КАКИХ-ЛИБО ГАРАНТИЙ, ЯВНЫХ ИЛИ ПОДРАЗУМЕВАЕМЫХ.",
          "disclaimer": "JH Heatsup ОТКАЗЫВАЕТСЯ ОТ ВСЕХ ГАРАНТИЙ, ЯВНЫХ ИЛИ ПОДРАЗУМЕВАЕМЫХ, ВКЛЮЧАЯ, НО НЕ ОГРАНИЧИВАЯСЬ, ПОДРАЗУМЕВАЕМЫМИ ГАРАНТИЯМИ ТОВАРНОЙ ЦЕННОСТИ, ПРИГОДНОСТИ ДЛЯ ОПРЕДЕЛЕННОЙ ЦЕЛИ, ПРАВА И НЕНАРУШЕНИЯ ПРАВ. Мы не гарантируем, что сайт будет работать бесперебойно, своевременно, безопасно и без ошибок."
        },
        "liability": {
          "title": "6. Ограничение ответственности",
          "description": "FUJIAN JINGHUI ENVIRONMENT TECHNOLOGY CO., LTD., ЕЕ ДОЛЖНОСТНЫЕ ЛИЦА, ДИРЕКТОРЫ, СОТРУДНИКИ ИЛИ АГЕНТЫ НЕ НЕСУТ ОТВЕТСТВЕННОСТИ ЗА ЛЮБЫЕ КОСВЕННЫЕ, СЛУЧАЙНЫЕ, СПЕЦИАЛЬНЫЕ, КОСВЕННЫЕ ИЛИ ШТРАФНЫЕ УБЫТКИ, ВОЗНИКАЮЩИЕ ИЗ ИЛИ СВЯЗАННЫЕ С ВАШИМ ИСПОЛЬЗОВАНИЕМ ЭТОТ ВЕБ-САЙТ ИЛИ ЛЮБЫЕ ПРОДУКТЫ ИЛИ УСЛУГИ, ПРИОБРЕТЕННЫЕ У НАС.",
          "limit": "Наша общая ответственность за любые претензии, возникающие из или в связи с настоящими условиями или нашими продуктами и услугами, не должна превышать сумму, уплаченную вами за продукты или услуги, послужившие основанием для такой претензии."
        },
        "privacy": {
          "title": "7. Политика конфиденциальности",
          "description": "Использование вами этого веб-сайта также регулируется нашей Политикой конфиденциальности, которая включена в настоящие Условия посредством ссылки. Пожалуйста, ознакомьтесь с нашей Политикой конфиденциальности, чтобы понять, как мы собираем, используем и защищаем вашу информацию."
        },
        "thirdPartyLinks": {
          "title": "8. Сторонние ссылки",
          "description": "Этот веб-сайт может содержать ссылки на сторонние веб-сайты, которые не принадлежат и не контролируются JH Heatsup. Мы не контролируем и не несем ответственности за контент, политику конфиденциальности или действия любых сторонних веб-сайтов. Вы получаете доступ к таким ссылкам на свой страх и риск.",
          "recommendation": "Мы рекомендуем вам ознакомиться с условиями и политикой конфиденциальности любого стороннего веб-сайта, который вы посещаете."
        },
        "governingLaw": {
          "title": "9. Применимое право и споры",
          "description": "Настоящие Условия регулируются и толкуются в соответствии с законодательством Китайской Народной Республики, без учета положений коллизионного права.",
          "disputes": "Любой спор, возникающий в связи с настоящими Условиями или использованием вами данного веб-сайта, подлежит разрешению путем добросовестных переговоров между сторонами. Если такие переговоры не увенчаются успехом, спор будет передан на рассмотрение обязательного арбитража в соответствии с правилами Китайской международной экономической и торговой арбитражной комиссии."
        },
        "export": {
          "title": "10. Экспортный контроль",
          "description": "Вы соглашаетесь соблюдать все применимые законы и правила экспортного контроля. Вы заявляете, что не находитесь в стране, не находитесь под ее контролем и не являетесь гражданином или резидентом какой-либо страны, на которую распространяются всеобъемлющие санкции или эмбарго США."
        },
        "termination": {
          "title": "11. Прекращение действия",
          "description": "Мы можем прекратить или приостановить ваш доступ к этому веб-сайту немедленно, без предварительного уведомления или ответственности, по любой причине, включая нарушение настоящих Условий. После прекращения действия ваше право на использование веб-сайта немедленно прекращается."
        },
        "changes": {
          "title": "12. Изменения настоящих Условий",
          "description": "Мы оставляем за собой право изменять или заменять настоящие Условия в любое время. Если изменение является существенным, мы предоставим уведомление за 30 дней до вступления в силу новых условий. Ваше дальнейшее использование веб-сайта после таких изменений означает принятие новых Условий."
        },
        "severability": {
          "title": "13. Делимость",
          "description": "Если какое-либо положение настоящих Условий будет признано недействительным, незаконным или не имеющим исковой силы, такое положение должно быть изменено в минимальной степени, необходимой для обеспечения его исковой силы, а остальные положения продолжат действовать в полную силу."
        },
        "contactUs": {
          "title": "14. Контактная информация",
          "description": "Если у вас есть какие-либо вопросы по поводу настоящих Условий обслуживания, свяжитесь с нами:",
          "email": "электронная почта",
          "address": "Адрес",
          "company": "Компания Fujian Jinghui Environmental Technology Co., Ltd.",
          "addressLine": "Здание 25, Научно-технологический парк Ваньян, 26 Tingwang Road, город Тинцзян, район Мавэй, Фучжоу, Фуцзянь, Китай"
        }
      }
    },
    "installationGuide": {
      "header": {
        "title": "Руководство по установке",
        "subtitle": "Выполните следующие действия для безопасной и эффективной установки JH Heatsup."
      },
      "safety": {
        "title": "Безопасность превыше всего",
        "description": "Установка должна выполняться квалифицированным электриком в соответствии с местными электротехническими нормами и правилами. Перед началом установки всегда проверяйте, чтобы питание на главной панели было отключено."
      },
      "toolsTitle": "Необходимые инструменты",
      "tools": {
        "electricDrill": "Электрическая дрель",
        "screwdriver": "Отвертка",
        "level": "Уровень",
        "measuringTape": "Измерительная лента",
        "wireStrippers": "Инструменты для зачистки проводов",
        "ladder": "Лестница"
      },
      "stepsTitle": "Этапы установки",
      "steps": {
        "step1": {
          "title": "Позиционирование и измерение",
          "description": "Выберите место на потолке или высокой стене. Для оптимальной работы обогреватель следует устанавливать на высоте от 2,2 до 2,5 м над полом. Отметьте точки сверления в соответствии с размерами монтажного кронштейна, указанными в коробке.",
          "bullet1": "Соблюдайте расстояние не менее 0,5 м от боковых стен.",
          "bullet2": "Обеспечьте минимальное расстояние 0,2 м от потолка (при настенном креплении)."
        },
        "step2": {
          "title": "Установка кронштейнов",
          "description": "Просверлите отверстия в отмеченных местах и вставьте дюбели. Надежно закрепите монтажные кронштейны на поверхности. Вставьте задние скользящие кронштейны обогревателя в установленные кронштейны и затяните регулировочные винты, чтобы установить нужный угол (0°, 15°, 30° или 45°)."
        },
        "step3": {
          "title": "Электрическое соединение",
          "description": "Подключите кабель питания к электросети. Обеспечьте правильное заземление. Для устройств с дистанционным управлением убедитесь, что глазок приемника виден, чтобы пульт работал эффективно.",
          "wireLive": "Л — Живой",
          "wireLiveColor": "Браун",
          "wireNeutral": "Н — нейтральный",
          "wireNeutralColor": "Синий",
          "wireEarth": "Е — Земля",
          "wireEarthColor": "Желтый/Зеленый"
        },
        "step4": {
          "title": "Тестирование",
          "description": "Включите питание. Нагреватель должен достичь полной рабочей температуры в течение 5 минут. При первом использовании вы можете заметить легкий запах; это нормально и быстро пройдет."
        }
      },
      "download": {
        "title": "Посмотреть руководство по продукту",
        "subtitle": "Получите доступ к полному руководству по установке со схемами для вашей конкретной модели.",
        "jhnr": "Посмотреть руководство",
        "industrial": "Посмотреть руководство"
      }
    },
    "warrantyPolicy": {
      "header": {
        "title": "Гарантийная политика",
        "subtitle": "Наша приверженность качеству и вашему спокойствию."
      },
      "overview": {
        "standardCoverage": "Стандартное покрытие",
        "standardCoverageDesc": "На продукцию JH Heatsup предоставляется гарантия отсутствия дефектов материалов и изготовления при нормальном использовании.",
        "warrantyPeriod": "Гарантийный срок",
        "residentialPeriod": "2 года для бытовых обогревателей.",
        "industrialPeriod": "1 год на промышленные обогреватели и контроллеры."
      },
      "sections": {
        "scope": {
          "title": "1. Объем гарантии",
          "description": "Данная гарантия распространяется на первоначального покупателя продукта и не подлежит передаче. Она охватывает ремонт или замену любой части продукта, в которой обнаружен дефект материала или изготовления, в течение гарантийного срока."
        },
        "notCovered": {
          "title": "2. Что не покрывается?",
          "description": "Данная гарантия не распространяется на повреждения, возникшие в результате:",
          "item1": "Неправильная установка, не соответствующая инструкции.",
          "item2": "Неправильное использование, злоупотребление, халатность или несчастный случай.",
          "item3": "Изменение или модификация продукта.",
          "item4": "Скачки напряжения или удары молнии.",
          "item5": "Нормальный износ (например, изменение цвета поверхности с течением времени)."
        },
        "claim": {
          "title": "3. Как подать претензию",
          "description": "Для получения гарантийного обслуживания обратитесь в нашу службу поддержки, предоставив следующую информацию:",
          "proofOfPurchase": "Подтверждение покупки (счет/чек)",
          "defectDescription": "Описание и фото/видео дефекта",
          "serialNumber": "Серийный номер устройства",
          "contactEmail": "Контактный адрес электронной почты"
        }
      }
    }
  },
  "features": {
    "tech": {
      "title": "Инновационный инфракрасный нагревательный элемент",
      "description": "Инфракрасные обогреватели JH излучают лучи дальнего инфракрасного диапазона, которые непосредственно согревают людей и предметы — так же, как естественный солнечный свет. Это лучистое отопление обеспечивает быстрое, равномерное и бесшумное тепло без шума, ветра, света и пыли, потребляя при этом на 80% меньше энергии, чем обычные конвекционные обогреватели.",
      "aluminum": "Специальный алюминиевый сплав ребристого типа для быстрой теплопроводности",
      "nano": "Запатентованное НАНО-керамическое покрытие для максимального инфракрасного излучения.",
      "insulation": "Эффективность излучения дальнего инфракрасного излучения 86 % — лучший результат в отрасли",
      "lifespan": "Запатентованная технология отражательного аккумулирования тепла (+20% экономии энергии)"
    }
  },
  "quote": {
    "getQuote": "Получить предложение",
    "title": "Получить бесплатное предложение",
    "modal": {
      "title": "Получить бесплатное предложение",
      "subtitle": "Заполните данные ниже, и наша команда свяжется с вами в течение 24 часов.",
      "fullName": "Полное имя",
      "email": "электронная почта",
      "phone": "Телефон",
      "productInterest": "Интерес к продукту",
      "message": "Сообщение",
      "placeholderName": "Джон Доу",
      "placeholderEmail": "john@example.com",
      "placeholderPhone": "+1 (555) 000-0000",
      "placeholderProduct": "например, промышленный обогреватель",
      "placeholderMessage": "Детали проекта, количество, требования к напряжению...",
      "submit": "Отправить запрос",
      "successTitle": "Запрос получен!",
      "successMessage": "Спасибо за ваш интерес. Один из наших специалистов по отоплению рассмотрит ваши требования и свяжется с вами в ближайшее время.",
      "close": "Закрыть"
    },
    "name": "Ваше имя",
    "email": "Адрес электронной почты",
    "phone": "Номер телефона",
    "company": "Название компании",
    "message": "Сообщение",
    "submit": "Отправить запрос",
    "success": "Спасибо! Мы свяжемся с вами в ближайшее время."
  },
  "faq": {
    "title": "Часто задаваемые вопросы",
    "subtitle": "Найдите ответы на распространенные вопросы о наших инфракрасных обогревателях.",
    "contactTitle": "Не можете найти то, что ищете?",
    "contactButton": "Свяжитесь с нами",
    "questions": {
      "whyChoose": {
        "title": "Почему стоит выбрать излучающие обогреватели дальнего инфракрасного диапазона?",
        "desc1": "Эффективность за пределами коэффициента конверсии: Хотя это правда, что кажущаяся степень конверсии энергии у обогревателей дальнего инфракрасного диапазона может быть ниже, чем у тепловых насосов, реальная экономия энергии и опыт пользователя говорят об обратном. Обогреватели дальнего инфракрасного диапазона предназначены для прямого нагрева предметов и людей в помещении, сводя к минимуму потери тепла и гарантируя, что тепло будет направлено туда, где оно больше всего необходимо.",
        "desc2": "Мощные, но энергосберегающие: благодаря надежному диапазону мощности от 1800 до 3200 Вт эти обогреватели способны обеспечивать значительную тепловую мощность. Однако их эффективность в распределении тепла означает, что вы можете достичь желаемого тепла с меньшим потреблением энергии, что в конечном итоге сэкономит на счетах за электроэнергию.",
        "desc3": "Повышенный комфорт: тепло дальнего инфракрасного диапазона известно своей способностью проникать глубже в материалы и живые ткани, обеспечивая более равномерное и комфортное тепло. Разница в том, что вы будете другим «Огнем» в космосе, а не куриными наггетсами во фритюрнице.",
        "desc4": "Универсальное решение для обогрева: в особенно суровые холодные дни излучающие обогреватели дальнего инфракрасного диапазона могут дополнять другие системы отопления, гарантируя, что ваше пространство будет постоянно теплым и уютным."
      },
      "getPrice": {
        "title": "Как узнать цену на дальние инфракрасные обогреватели?",
        "desc": "Вы можете нажать на нашу страницу контактов и оставить нам сообщение о том, что и где. Мы будем цитировать запросы с точными потребностями."
      },
      "services": {
        "title": "Какие услуги вы предоставляете?",
        "item1": "Стандартизированные образцы (2+ шт.) Быстрая доставка, 3–15 дней, количество дополнительных вилок ограничено.",
        "item2": "Стандартизированный средний заказ (20+ штук), 15-30 дней, легкая индивидуализация (логотип, упаковка товара, транспортировочная упаковка)",
        "item3": "Массовые заказы стандартной продукции (300~2000+ штук), 45-60 дней, дополнительные дополнительные услуги (особый внешний вид, дополнительные функции, специальные стандарты)",
        "note": "Вышеуказанные услуги применимы к изделиям с электрическими нагревателями."
      },
      "energyEfficient": {
        "title": "Являются ли дальние инфракрасные обогреватели более энергоэффективными?",
        "desc1": "Обогреватели дальнего инфракрасного диапазона преобразуют электрическую энергию в дальнее инфракрасное излучение, которое затем поглощается предметами в комнате, что приводит к повышению температуры. Эффективность дальнего инфракрасного обогревателя зависит от нескольких факторов, включая размер помещения, изоляцию и тип обогревателя. В среднем обогреватели дальнего инфракрасного диапазона считаются более энергоэффективными, чем традиционные системы отопления, поскольку они непосредственно нагревают объекты, уменьшая количество энергии, теряемой за счет конвекции.",
        "desc2": "Однако фактическая энергоэффективность может варьироваться в зависимости от режима использования и факторов окружающей среды. Для определения энергоэффективности рекомендуется ознакомиться со спецификациями продукции и отзывами клиентов."
      },
      "coveringArea": {
        "title": "Какова площадь покрытия обогревателя JH?",
        "desc": "Площадь покрытия зависит от размера помещения, условий изоляции и высоты потолка. Как правило, наши обогреватели предназначены для эффективного обогрева помещений в зависимости от их характеристик мощности."
      },
      "howWork": {
        "title": "Как работают инфракрасные обогреватели JH?",
        "desc1": "Классический конвекционный обогреватель изначально нагревает циркулирующий воздух. Наши инфракрасные нагревательные панели в первую очередь заботятся о людях и объектах, а не о воздухе вокруг них. Инфракрасные лучи за короткое время нагревают кожу, и это теплое свечение распространяется по всему телу. Таким образом, вы довольно скоро почувствуете комфортное тепло, в то время как окружающий воздух может быть прохладнее.",
        "benefit1": "Он нагревает человеческое тело напрямую с помощью дальнего инфракрасного диапазона, вместо того, чтобы тратить много энергии на нагрев воздуха.",
        "benefit2": "По сравнению с другими лучистыми обогревателями, он имеет гораздо более высокую эффективность электрического обогревателя, поскольку в нашем обогревателе используется новая нанотехнология.",
        "benefit3": "Это намного удобнее, чем другие электрические обогреватели.",
        "desc2": "На этом рисунке показана разница между обычным инфракрасным обогревателем и конвекционным инфракрасным обогревателем."
      },
      "operatingCost": {
        "title": "Сколько стоит эксплуатация инфракрасных обогревателей JH?",
        "desc1": "Если предположить, что тариф на электроэнергию составляет 0,35 евро за киловатт-час, эксплуатационные расходы на обогреватели JH варьируются от 0,63 евро в час (1800 Вт) до 1,12 евро в час (3200 Вт).",
        "desc2": "Для сравнения, работа гораздо менее эффективного обогревателя «грибного типа» мощностью 13 кВт обходится в 4,55 евро в час, то есть в четыре раза дороже, чем самая мощная и самая длинная модель."
      },
      "difference13A14A": {
        "title": "В чем разница между обогревателем 13A и обогревателем 14A?",
        "desc": "Разница заключается только в конструкции излучающей панели, внутренний нагревательный элемент и конструкция одинаковы, а эффективность нагрева также одинакова."
      },
      "installationHeight": {
        "title": "Какая высота установки оптимальна?",
        "desc": "Рекомендуемая высота установки от 1,8 до 2,5 метров."
      },
      "whyShortWave": {
        "title": "Почему короткие волны?",
        "desc1": "По сути, чем короче волна, тем легче она распространяется по воздуху. Коротковолновое инфракрасное излучение генерирует тепло, нагревая объект, с которым он встречается, без нагревания воздуха вокруг него. Даже эффективный и мгновенный нагрев без предварительного нагрева.",
        "desc2": "Хорошим примером такого действия является эффект, возникающий, когда человек выходит из тени на солнечный свет. Хотя температура окружающей среды остается прежней, они ощущают, что под прямыми солнечными лучами температура значительно выше."
      }
    }
  }
} satisfies ModularLocaleModules;
